import React, { useState, useMemo } from "react";
import GeneralButton from "../../mainComponents/generalButton";
import { useNavigate } from "react-router-dom";
import CustomAppBar from "../../mainComponents/appBar";
import BigTitle from "../../mainComponents/bigTitle";
import { cn } from "../../mainComponents/cn";
import { updateRegistrationData } from "../../utils/localStorageHelper";
import { STRINGS } from "../../utils/strings";

const AgeGate: React.FC = () => {
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState<string>("January");
  // const [selectedYear, setSelectedYear] = useState<string>("2025");
  // const [selectedMonth, setSelectedMonth] = useState<string>(String(new Date().toLocaleString('default', { month: 'long' })));
  const [selectedYear, setSelectedYear] = useState<string>(String(new Date().getFullYear() - 14));
  const [errorMessage, setErrorMessage] = useState<string | null>(null); 

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => String(currentYear - 14 - i));

  const calculateAge = useMemo(() => {
    const birthMonth = STRINGS.months.indexOf(selectedMonth);
    const birthYear = parseInt(selectedYear);

    const today = new Date();
    const currentMonth = today.getMonth();

    let age = today.getFullYear() - birthYear;
    if (currentMonth < birthMonth || (currentMonth === birthMonth && today.getDate() < 1)) {
      age--;
    }
    return age;
  }, [selectedMonth, selectedYear]);

  const handleContinue = () => {
    if (calculateAge < 14) {
      setErrorMessage("You must be at least 14 years old to proceed.");
      return; 
    }

    setErrorMessage(null);

    updateRegistrationData({ age: calculateAge });

    navigate("/platform"); 
  };

  return (
    <div className="flex flex-col items-center justify-between pt-10 h-screen overflow-hidden bg-[#1a2630] text-white p-5 font-custom">
      <CustomAppBar />

      <div className="flex flex-col items-center mt-10 mb-auto">
        <BigTitle text="Confirm" />
        <BigTitle text="your age" />

        <div className="flex justify-between w-full max-w-xs gap-10 mt-10">
          {/* Month selector */}
          <div className="w-1/2">
            <div className="h-52 overflow-y-auto no-scrollbar pr-2">
              <div className="flex flex-col space-y-2">
                {STRINGS.months.map((month) => (
                  <button
                    key={month}
                    onClick={() => setSelectedMonth(month)}
                    className={cn(
                      "py-3 px-4 rounded-full text-center transition-colors w-full",
                      selectedMonth === month
                        ? "bg-[#3a4550] text-white font-semibold"
                        : "text-gray-400"
                    )}
                  >
                    {month}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Year selector */}
          <div className="w-1/2">
            <div className="h-52 overflow-y-auto no-scrollbar pr-2">
              <div className="flex flex-col space-y-2">
                {years.map((year) => (
                  <button
                    key={year}
                    onClick={() => setSelectedYear(year)}
                    className={cn(
                      "py-3 px-4 rounded-full text-center transition-colors w-full",
                      selectedYear === year
                        ? "bg-[#3a4550] text-white font-semibold"
                        : "text-gray-400"
                    )}
                  >
                    {year}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-sm text-white mb-2">
        <span className="font-semibold">{calculateAge}</span> years old
      </p>

      {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}

      <GeneralButton text="Continue" color="white" onClick={handleContinue} />

      <p className="text-xs text-gray-400 text-center px-4 leading-snug">
        By continuing, you agree to our <span className="text-white font-semibold">Terms of Use</span> and have read and agreed to our <span className="text-white font-semibold">Privacy Policy</span>
      </p>
    </div>
  );
};

export default AgeGate;
